<template>
  <div class="security-select-wrap">
    <el-dialog :title="setData.TopTitle || '选择人员'"
               :visible.sync="showPanel"
               width="850px"
               v-dialogDrag
               :modal="false"
               class="dialog"
               @close="close">
      <div class="content">
        <div class="content-top">
          <div class="content-top-left active-border-color">
            <h4 class="title">{{setData.leftTitle || '左侧数据'}}</h4>
            <el-input placeholder="请输入账户名称"
                      v-model="account"
                      clearable
                      class="input-with-select"
                      style="width: 95%;margin: 10px 0">
              <el-button slot="append"
                         icon="el-icon-search"></el-button>
            </el-input>
            <ul class="group-list">
              <el-tree class="tree-list"
                       ref="tree"
                       node-key="id"
                       :data="treeData"
                       :props="props"
                       :default-checked-keys="defaultChecked"
                       :renderContent="renderContent"
                       :filter-node-method="filterNode"
                       show-checkbox>
              </el-tree>
            </ul>
          </div>
          <div class="content-top-middle">
            <el-button class="to-left"
                       plain
                       icon="el-icon-arrow-right"
                       circle
                       size="medium"
                       @click="transferPerson('left')"></el-button>
            <el-button class="to-right"
                       plain
                       icon="el-icon-arrow-left"
                       circle
                       size="medium"
                       @click="transferPerson('right')"></el-button>
          </div>
          <div class="content-top-right active-border-color">
            <h4 class="title">{{setData.rightTitle || '右侧数据'}}</h4>
            <ul class="person-list">
              <el-checkbox v-model="checkedAll"
                           @change="checkChang"
                           style="margin-bottom:10px">全选</el-checkbox>
              <li v-for="(item, index) in selectedList"
                  :key="index"
                  style="position: relative;"
                  class="person">
                <el-checkbox v-model="item.checked"
                             @change="itemChang"
                             style="margin-right:8px"></el-checkbox>
                <span class="checked-name"
                      :title="item.name">{{ item.name }}</span>
                <span style="position: absolute;right:0"
                      v-if="setData.showSelect">
                  <el-radio v-model="item.personType"
                            label="1">管理员</el-radio>
                  <el-radio v-model="item.personType"
                            label="2">普通用户</el-radio>
                </span>

              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="close"
                   :loading="subLoading">{{subLoading?"确认中":"取消"}}</el-button>
        <el-button type="primary"
                   @click="submit"
                   :loading="subLoading">{{subLoading?"确认中":"确认"}}</el-button>

      </div>
    </el-dialog>

  </div>
</template>

<script>
import { api } from '../api'
import { Cache } from '$utils'
export default {
  watch: {
    account (val) {
      this.$refs.tree.filter(val);
    }
  },
  components: {},
  props: {
    setData: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      subLoading: false,
      showPanel: false,
      childrenDataList: [],
      props: {
        label: "name",
        // children: "children",
        id: "code",
        isLeaf: "isLeaf"
      },
      treeData: [],
      selectedList: [],
      //判断是否已经开始懒加载
      isLoadNode: false,
      account: '',
      checkedAll: false,
      defaultChecked: [],
      params: {
        accountType: "1",
        pageNo: 1,
        pageSize: 10,
        parkId: "200000001"
      }

    }
  },

  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  created () { },
  mounted () { },
  beforeDestory () { },
  methods: {
    checkChang (val) {
      this.selectedList.some(el => {
        el.checked = val == true ? true : false
      })
    },
    itemChang (val) {
      let checkedAlls = this.selectedList.every(el => {
        return el.checked == val
      })
      if (checkedAlls == true) {
        this.checkedAll = val
      } else {
        this.checkedAll = false
      }
    },
    check (value) {
      this.$nextTick(() => {
        if (!value.isLeaf && !value.children.length) {
          let param = { "accountGroupCode": value.code };
          this.$fetch(api.workOrder.queryAccountGroup, param).then(res => {
            if (res.success) {
              if (res.returnObj && res.returnObj.length) {
                this.childrenDataList = res.returnObj.map(item => {
                  return {
                    code: item.accountNumber,
                    name: `${item.nickName}(${item.accountNumber})`,
                    isLeaf: true
                  }
                })
              } else {
                this.childrenDataList = [];
              }
              this.$set(value, 'children', this.childrenDataList);
            } else {
              this.$message.error(res.msgContent);
            }
          })
        }
      })
    },
    async open (data) {
      this.showPanel = true;
      this.getInList()
      await this.getRlatAccountGroup()
    },
    // 获取所有安保账户
    getRlatAccountGroup () {
      this.$fetch(api.workOrder.queryWorkerList).then(res => {
        if (res.success) {
          this.treeData = res.returnObj;
          this.defaultChecked = []
          if (this.selectedList.length) {
            this.selectedList.map(el => {
              this.filterTreeData(this.treeData, el.code, true)
              this.defaultChecked.push(el.code)
            })
          } else {
            var timeId = setInterval(() => {
              if (this.selectedList.length) {
                clearInterval(timeId)
              }
              this.$nextTick(() => {
                this.selectedList.map(el => {
                  this.filterTreeData(this.treeData, el.code, true)
                  this.defaultChecked.push(el.code)
                })
              })
            }, 100);
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 获取当前在当前保卫工作组保卫信息
    getInList () {
      let params = {
        workOrderRelationCode: this.setData.code,
        workOrderRightType: "1",//工单权限类型 1：工单工作组 2：工单模板
      }
      this.$fetch(api.workOrder.getWorkerList, params).then(res => {
        if (res.success) {
          if (res.returnObj && res.returnObj.workOrderRightPersonList.length) {
            this.selectedList = res.returnObj.workOrderRightPersonList.map(item => {
              return {
                code: item.accountNumber,
                // name: `${item.nickName}(${item.accountNumber})`,
                name: item.nickName,
                checked: true,
                personType: item.personType,
              }
            })
            this.checkedAll = true
          }
          // this.filterList(this.selectedList)
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // left过滤已经选中的数据
    filterList (data) {
      let checkList = data.map(el => {
        return el.code
      })
      let list = this.treeData.filter(item => {
        if (!checkList.includes(item.code)) {
          return item
        }
      })
      this.treeData = list
    },
    // 自定义渲染节点
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>);
    },
    // 移动人员
    transferPerson (type) {
      if (type === "left") {
        // 获取左边未选中的人员 (左侧列表勾选的)        
        let selectedPerson = this.$refs.tree.getCheckedNodes().filter(el => {
          return el.nodeType === 'security'
        });
        if (selectedPerson.length) {
          if (this.selectedList.length == 0) {
            this.checkedAll = true
          }
          selectedPerson = selectedPerson.map(item => {
            return {
              code: item.id,
              name: item.name,
              checked: true,
              personType: item.personType || "2"
            }
          });
          this.selectedList = this.selectedList.concat(selectedPerson);
          // let data = this.selectedList.map(item => {
          //   return {
          //     code: item.code,
          //     name: item.name,
          //     checked: true
          //   }
          // });

          // // 人员根据账号去重          
          this.selectedList = this.reduceArr(this.selectedList, "code");
          // // 当勾选中后改变左侧树checked的属性值
          // this.treeData.forEach((item, index) => {
          //   selectedPerson.forEach((items) => {
          //     if (items.code === item.code) {
          //       item.checked = items.checked
          //     }
          //   })
          // })
          // this.treeData = this.treeData.filter(item => item.checked === false)
          // this.filterTreeData(this.treeData)
          this.selectedList.map(el => {
            this.filterTreeData(this.treeData, el.code, true)
          })
        } else {
          selectedPerson = this.$refs.tree.getCheckedNodes(true);
        }

      } else if (type === "right") {
        this.checkedAll = false
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(item => item.checked === true)//偏移数组
          this.selectedList = this.selectedList.filter(item => item.checked === false);
          console.log(rightChoose)
          rightChoose.map(el => {
            this.filterTreeData(this.treeData, el.code, false)
          })
          // this.treeData = this.treeData.concat(rightChoose)
          // this.selectedList.map(el => {
          //   this.filterTreeData(this.treeData, el.code)
          // })
          // this.treeData = this.reduceArr(this.treeData, "code");
        } else {
          this.selectedList = [];
        }
      }
    },
    filterTreeData (data, val, isShow) {
      const self = this
      if (data !== null) {
        data.forEach(function (item) {
          //  item.disabled = true
          if (item.nodeType == 'security' && item.id == val) {
            if (isShow == true) {
              item.name = item.disabled ? item.name : item.name + '【已选】'
              item.disabled = true
            } else {
              item.name = item.name.split("【")[0]
              item.disabled = false
              // delete item.disabled
            }
            item = JSON.parse(JSON.stringify(item))
            // self.$set(item, 'disabled', true)
          }
          if (item.children) {
            self.filterTreeData(item.children, val, isShow)
          }
        })
      }
    },
    // 根据key对数组对象去重
    reduceArr (arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : obj[next[key]] = true && cur.push(next);
        return cur;
      }, []);
      return newArr;
    },
    //点击确定按钮,对外暴露已选人员
    submit () {
      if (this.selectedList.length) {
        let chooseIds = []
        // this.selectedList.filter(item => item.checked === true)
        this.selectedList.forEach(item => {
          chooseIds.push({
            accountNumber: item.code,
            personType: item.personType
          })
        });
        let params = {
          workOrderRightPersonList: chooseIds,
          workOrderRelationCode: this.setData.code,
          workOrderRightType: "1"
        }
        this.subLoading = true
        this.$fetch(api.workOrder.updateWorkerList, params).then(res => {
          setTimeout(() => {
            this.subLoading = false
          }, 200);
          if (res.success) {
            this.$message.success('新增人员成功');
            this.close();
            this.$emit("refreshData")
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        this.$message.warning('请选择人员名单');
      }
    },
    close () {
      this.showPanel = false;
      this.selectedList = [];
      this.treeData = []
      this.account = ''
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  }
}
</script>
<style lang="scss" >
@import "~@src/common/assets/style/mixin";
.security-select-wrap {
  .el-tree-node {
    .is-disabled {
      .el-checkbox__input {
        .el-checkbox__inner {
          @include set_theme_color(background-color, main-button-bgcolor);
          @include set_theme_color(border-color, main-button-bgcolor);
        }
      }
    }
  }
  .content {
    &-top {
      display: flex;
      justify-content: space-around;
      align-content: space-around;
      text-align: center;
      padding-bottom: 30px;
      &-left,
      &-right {
        width: 48%;
        height: 350px;
        border-width: 1px;
        border-style: solid;

        h2 {
          background-color: rgba(38, 43, 55, 1);
          margin-bottom: 0;
        }
        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          height: calc(100% - 90px);
          overflow-y: scroll;
        }
        .person-list {
          text-align: left;
          padding: 5px 10px;
          height: calc(100% - 36px);
          overflow-y: scroll;
          .person {
            display: flex;
            padding: 5px 0px;
            color: #b9c3d9;
            font-size: 14px;
            .name-icon {
              margin: 0 5px;
            }
            .checked-name {
              display: inline-block;
              max-width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      &-middle {
        .to-left {
          margin: 100px 0px 10px 0px;
          background: transparent;
        }
        .to-right {
          margin-left: 2px;
          background: transparent;
        }
      }
    }
  }
  .dialog {
    .el-dialog__body {
      padding: 30px;
    }
  }
  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
  }
  .title {
    height: 36px;
    line-height: 36px;
    font-weight: normal;
  }
  .tree-list .personwidth {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #b9c3d9;
  }
  .tree-list .el-tree .is-current > .el-tree-node__content,
  .tree-list .el-tree-node__content:hover {
    background-color: transparent;
  }
  .person-list .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: #c9d5ec;
  }
  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }
}
</style>